export function toBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}

export function toNumericId(shopifyGid) {
    try {
        let fragments = shopifyGid.split('/')
        return fragments[fragments.length - 1];
    } catch (TypeError) {
        return shopifyGid
    }
}
